//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  const memoryStore = {}

  const storage = {
    getItem (key) {
      try {
        return sessionStorage.getItem(key)
      } catch (e) {
        return memoryStore[key] !== undefined ? memoryStore[key] : null
      }
    },
    setItem (key, value) {
      try {
        sessionStorage.setItem(key, value)
      } catch (e) {
        memoryStore[key] = String(value)
      }
    }
  }

  export default {
    name: 'Loading',
    props: {
      message: {
        type: String,
        default: ''
      }
    },
    data () {
      const circumference = 2 * Math.PI * 44
      return {
        currentTheme: 0,
        totalTime: 0,
        maxTime: 0,
        circumference,
        clock: null
      }
    },
    computed: {
      dashOffset () {
        return this.maxTime === 0 ? 0 : this.circumference * (1 - this.totalTime / this.maxTime)
      }
    },
    mounted () {
      const theme = storage.getItem('theme')
      this.currentTheme = theme === null ? 1 : Number(theme)

      const orderNo = this.$router.currentRoute.query.order_no
      const maxTtlKey = `max_ttl_${orderNo}`
      this.$models.Deposit.resource({ order_no: orderNo })
        .then(response => {
          const diff = (response.data.data && response.data.data.ttl)
          const stored = storage.getItem(maxTtlKey)
          if (stored) {
            this.maxTime = Number(stored)
          } else {
            this.maxTime = diff
            storage.setItem(maxTtlKey, diff)
          }
          this.totalTime = diff
          this.startCountDown()
        })
        .catch(() => {
          this.$router.replace({
            path: '/error',
            query: {
              title: `${this.$t('channelUnavailable')}`,
              description1: `${this.$t('recreateOrder')}`
            }
          })
        })
    },
    beforeDestroy () {
      if (this.clock) {
        window.clearInterval(this.clock)
      }
    },
    methods: {
      startCountDown () {
        this.clock = window.setInterval(() => {
          this.totalTime--
          if (this.totalTime < 1) {
            window.clearInterval(this.clock)
            this.$router.replace({
              path: '/error',
              query: {
                title: `${this.$t('channelUnavailable')}`,
                description1: `${this.$t('recreateOrder')}`
              }
            })
          }
        }, 1000)
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/Loading.vue